import { PhaseView } from './PhaseView'
export function Phase2View() {
  return <PhaseView phase="p2" />
}
